<ul>
  @for (alert of alerts; track alert) {
    <li @modalSlideInOut role="alert">
      @switch (alert.status) {
        @case ("success") {
          <img src="/assets/images/alert-success.svg" alt="Success icon" />
        }
        @case ("error") {
          <img src="/assets/images/alert-error.svg" alt="Error icon" />
        }
        @case ("warn") {
          <img src="/assets/images/alert-warning.svg" alt="Warning icon" />
        }
        @case ("info") {
          <img src="/assets/images/alert-info.svg" alt="Info icon" />
        }
      }
      <section class="alert-text">
        <h1 class="alert-title">{{ alert.title }}</h1>
        @if (alert.message) {
          <p class="alert-message">{{ alert.message }}</p>
        }
      </section>
      <button (click)="remove(alert)">Close</button>
    </li>
  }
</ul>
